module.exports = __webpack_public_path__ + "media/images/faces/face6-18defd341d8162305133fd7b5bed5ec6.jpg";